module.exports = __webpack_public_path__ + "media/slider/Banner-7-75d01109.jpg";